import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function PagamentoCancelado() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isFromCheckout = location.state && location.state.fromCheckout;

    if (!isFromCheckout) {
      // Se o usuário não veio da página de checkout, redireciona imediatamente
      navigate('/login', { replace: true });
    } else {
      // Redireciona após 5 segundos
      const timer = setTimeout(() => {
        navigate('/login', { replace: true });
      }, 5000);

      // Limpa o timeout se o componente for desmontado
      return () => clearTimeout(timer);
    }
  }, [navigate, location.state]);

  return (
    <div className="pagamento-cancelado-container">
      <h1>Pagamento Cancelado</h1>
      <p>
        Seu pagamento foi cancelado. Você será redirecionado para a página de
        login em breve.
      </p>
      <button onClick={() => navigate('/cadastrar')}>
        Voltar para Registro
      </button>
    </div>
  );
}

export default PagamentoCancelado;
